import React from 'react'

import SidePanel, { Divider } from '../sidepanel/sidePanel'
import { useUser } from '../../pages/session/hooks'
import TrInput from '../sidepanel/trInput'
import TrFile from '../sidepanel/trFile'
import POWERS from '../../powers'
import Period from '../period'

const Deal = ({ deal, customerSOW, onDealChanged, onCustomerSOWChanged }) => {
  const user = useUser()

  if (!deal) {
    return null
  }

  return (
    <React.Fragment>
      <SidePanel>
        <tbody>
          <tr>
            <th>Status</th>
            {deal.active ? (
              <td style={{ color: 'var(--olive)', fontWeight: 'bold' }}>
                Active {deal.effectiveDate > Date.now() && ' - Not started yet'}
              </td>
            ) : (
              <td style={{ color: 'var(--red)', fontWeight: 'bold' }}>
                Terminated {deal.endDate > Date.now() && '- Not ended yet'}
              </td>
            )}
          </tr>

          <tr>
            <th>SOW Effective Date</th>
            <td
              style={{
                color: deal.effectiveDate > Date.now() && 'var(--green)',
              }}
            >
              {new Date(deal.effectiveDate).toLocaleDateString('en-US')} (
              <Period date={deal.effectiveDate} />)
            </td>
          </tr>

          {deal.endDate && (
            <tr>
              <th>SOW End Date</th>
              <td
                style={{
                  color: deal.endDate > Date.now() && 'var(--green)',
                }}
              >
                {new Date(deal.endDate).toLocaleDateString('en-US')} (
                <Period date={deal.endDate} />)
              </td>
            </tr>
          )}

          <TrInput
            key={deal.position}
            name="position"
            label="Position"
            placeholder="Position..."
            value={deal.position}
            url={`deals/${deal._id}`}
            onSuccess={onDealChanged}
            disabled={!user.hasPower(POWERS.updateDeal)}
          />
        </tbody>
      </SidePanel>

      {/* this is moved to the contract.
        <tr>
          <th>Customer</th>
          <td>
            <a href={`/companies/${deal.customerId}`} target="_blank">
              <CompanyName id={deal.customerId} />
            </a>
          </td>
        </tr> */}

      {customerSOW && (
        <>
          <Divider />
          <SidePanel>
            <tbody>
              <tr>
                <th>Customer Rate</th>
                <td>
                  $ {customerSOW.monthlyRate} ($ {customerSOW.hourlyRate} per
                  hour)
                </td>
              </tr>

              <TrFile
                key={deal._id + customerSOW.sow}
                name="sow"
                label="Customer SOW"
                value={customerSOW.sow}
                url={`customerSOWs/${customerSOW._id}`}
                fileUrl={`cdn/customer-sows/sow-${customerSOW._id}`}
                onSuccess={onCustomerSOWChanged}
              />
            </tbody>
          </SidePanel>
        </>
      )}

      <Divider />

      <SidePanel>
        <tbody>
          <tr>
            <th>Contractor Fee</th>
            <td>
              $ {deal.monthlySalary} ($ {deal.hourlySalary} per hour)
            </td>
          </tr>

          <TrFile
            key={deal.contractorSOW}
            name="contractorSOW"
            label="Contractor SOW"
            value={deal.contractorSOW}
            url={`deals/${deal._id}`}
            fileUrl={`cdn/contractor-sows/contractor-sow-${deal._id}`}
            onSuccess={onDealChanged}
            disabled={!user.hasPower(POWERS.updateDeal)}
          />
        </tbody>
      </SidePanel>

      <Divider />
      <SidePanel>
        {' '}
        <tbody>
          {' '}
          <tr>
            <th>Hour Method</th>
            <td>{deal.hourCalculationMethod}</td>
          </tr>
        </tbody>
      </SidePanel>
    </React.Fragment>
  )
}

export default Deal
